import React, { useContext } from "react";
import { Avatar, Card, Divider, IconButton } from "react-native-paper";
import { Text, View } from "../../shared/Themed";
import { StyleSheet, ScrollView, Image } from "react-native";
import Spinner from "../../shared/Spinner";

import DeviceOrientationContext from "../../context/DeviceOrientationContext";
import { ReadOnlyProps } from "../../../utils/templates";

interface Props {
  childern: React.ReactNode | JSX.Element;
  title: string;
  subTitle?: string;
  icon?: string;
  loading?: boolean;
  uri?: string;
  cardContainerHeight?: string;
  setModalVisible?: (event: any) => void;
  modalVisible?: boolean;
}

export const ModalContent: React.FC<ReadOnlyProps<Props>> = (
  props: ReadOnlyProps<Props>
) => {
  const { isMediumDevice, isSmallDevice } = useContext(
    DeviceOrientationContext
  );

  const leftContent = () => {
    if (!props.icon) return null;
    return (
      <Avatar.Icon 
        size={32} 
        icon={props.icon} 
        color="#2F95DC" 
        style={{ backgroundColor: "#E3F2FD" }} 
      />
    );
  };

  return (
    <View
      style={[
        styles.cardViewContainer,
        {
          width: isSmallDevice ? "100%" : 500,
          minWidth: isSmallDevice ? "100%" : isMediumDevice ? "30%" : "24%",
          minHeight: isSmallDevice ? "75%" : "80%",
          maxHeight: isSmallDevice ? "94%" : "100%",
          flex: 1,
        },
      ]}
    >
      <Card mode="outlined" style={[styles.cardContainer, , { height: props.cardContainerHeight ? props.cardContainerHeight : "100%" }]}>
        <Card.Title
          style={styles.cardTitle}
          title={props.title}
          subtitle={
            props.subTitle ? (
              <Text style={{ flex: 1, flexWrap: "wrap" }}>
                {props.subTitle}
              </Text>
            ) : null
          }
          left={leftContent}
          leftStyle={{
            display: props.icon === undefined ? "none" : "flex",
            padding: 0,
            marginRight: 0,
          }}
          right={(rightProps) => (
            props.setModalVisible ? (
              <IconButton
                {...rightProps}
                icon="close"
                onPress={() => props.setModalVisible && props.setModalVisible(false)}
              />
            ) : null
          )}
        />
        <Divider />
        {props.uri !== undefined ? (
          !props.loading ? (
            <>
              <Image style={styles.cardImage} source={{ uri: props.uri }} />
              <Divider />
            </>
          ) : (
            <>
              <View style={styles.spinnerContainer}>
                <Spinner
                  size="small"
                  color="#74BBFF"
                  styles={{ flexDirection: "row" }}
                />
              </View>
              <Divider />
            </>
          )
        ) : (
          <View></View>
        )}

        <ScrollView style={{ flex: 1 }} contentContainerStyle={{ flexGrow: 1 }}>
          <Card.Content style={styles.cardContent}>{props.childern}</Card.Content>
        </ScrollView>
      </Card>
    </View>
  );
};

const styles = StyleSheet.create({
  cardViewContainer: {
    flexDirection: "row",
    backgroundColor: "transparent",
  },
  cardContainer: {
    width: "100%",
    // height: "60%",
    borderColor: "#E2E8F0",
    borderWidth: 1,
    borderRadius: 8,
    backgroundColor: "white",
    alignItems: "center",
    justifyContent: "flex-start",
    flex: 1,
  },
  cardImage: {
    resizeMode: "contain",
    width: "100%",
    height: "60%",
    justifySelf: "center",
    alignSelf: "center",
  },
  spinnerContainer: {
    width: "100%",
    height: "50%",
    justifyContent: "center",
    alignItems: "center",
  },
  cardTitle: { width: "100%", marginTop: "2%" },
  cardContent: { marginBottom: 10, width: "100%", marginTop: 10, paddingHorizontal: 4 },
});
